module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAYAAACpSkzOAAAAAXNSR0IArs4c6QAAAMNJREFUSEvtllENQjEMRc9zgAQkIAEc4AAcAArgKQAcYAEF4AAkIIXcZCMLvAcNHQkf7d+Wrmftbrc1dNsa2AArYFe4DIFTGk+AW8/6l+mmx1HBxsAZUMBsmssgQcwwD0hwM8wLMsM8oCswSjX9mJkHpPOZAzMLzAuSWA4WWA2QEiphR2D6rOZaIMVVvy2APbD8JUix1dCdTVwzo7eXRIDKu059JHmbLEoXpXsIJcQQYvgfMejh2gJt+kjmnQ2AyzcfyDtDAHcbM1+ihwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/supplyHome/Slice 15@2x.png
// module id = NY6b
// module chunks = 2